// Copyright © 2021 Move Closer
import { computed } from '@vue/composition-api';
import { NavVariant } from './Nav.contracts';
/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const abstractNavProps = {
    /**
     * The ID of the currently-active item.
     */
    activeItem: {
        type: String,
        required: true
    },
    /**
     * Items to render.
     */
    items: {
        type: Array,
        required: true
    },
    variant: {
        type: String,
        required: false,
        default: NavVariant.Underlined
    }
};
/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const useNav = (props, ctx) => {
    // Extract the `emit()` function.
    const { emit } = ctx;
    /**
     * The ID of the currently-active tab.
     */
    const _activeItem = computed({
        get() {
            return props.activeItem;
        },
        set(value) {
            emit('update:activeItem', value);
        }
    });
    /**
     * Activates the item of a passed-in ID.
     *
     * @param id - The ID of the item that is to be set as 'active'.
     */
    const activateItem = (id) => {
        _activeItem.value = id;
    };
    /**
     * Checks if the item of a passed-in ID is the currently-active one.
     *
     * @param id - The ID of the item that is to be checked.
     */
    const isItemActive = (id) => {
        return _activeItem.value === id;
    };
    const variantClass = computed(() => props.variant ? `nav--${props.variant}` : '');
    return { _activeItem, activateItem, isItemActive, variantClass };
};
